var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var VueTooltipRenderer = /** @class */ (function () {
    function VueTooltipRenderer(Vue, param) {
        if (param === void 0) { param = {}; }
        this._Vue = Vue;
        this._param = param;
    }
    VueTooltipRenderer.prototype.init = function (dom, option) {
        var _this = this;
        this._dom = dom;
        var mountNode = document.createElement('div');
        dom.appendChild(mountNode);
        setTimeout(function () {
            _this._tooltip = new _this._Vue(__assign(__assign({ el: mountNode, data: function () {
                    return {
                        mouse: { x: 0, y: 0 },
                        points: [],
                        title: '',
                    };
                } }, _this._param), { template: "<div :class=\"(mouse.x, mouse.y, '')\">" + option.formatter + "</div>", updated: function () {
                    if (_this.updateCallback) {
                        _this.updateCallback();
                    }
                } }));
        }, 0);
    };
    VueTooltipRenderer.prototype.update = function (dom, formatContent, tooltipParam) {
        if (!this._tooltip) {
            return;
        }
        this._tooltip.title = tooltipParam.title;
        this._tooltip.points = tooltipParam.points;
        this._tooltip.mouse = tooltipParam.mouse;
    };
    VueTooltipRenderer.prototype.destroy = function () {
        var _a;
        (_a = this._tooltip) === null || _a === void 0 ? void 0 : _a.$destroy();
        this._dom.innerHTML = '';
    };
    return VueTooltipRenderer;
}());
export default VueTooltipRenderer;
